import { http } from './http';

export function getSimilarList(category, id, { language } = {}) {
  const params = language ? { language } : undefined;
  return http.get(`/api/v1/media/${category}/${id}/similar`, { params }).then((r) => r.data);
}

export function submitSimilarityVote(category, baseId, payload) {
  return http
    .post(`/api/v1/media/${category}/${baseId}/similarity-vote`, payload)
    .then((r) => r.data);
}
